import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import { Politica } from "../../../_models/politica";
import { CentralizadaPoliticas } from "../../../_models/gestor-politicas";
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { SelectItem } from "primeng/api";
import { ListaService } from "../../../_services/lista.service";
import { NavService } from "../../../_services/_nav.service";
import {forkJoin, Observable} from 'rxjs';
import { PoliticasVinculacionesService } from '../../../_services/politicas-vinculaciones.service';
import {CanalComunicacion, CodigosPoliticas, Listas, PoliticaAPL} from '../../../_enums/enum';
import {Estado} from '../../../_models/estado';
import {ListaItem} from '../../../_models/lista-item';
import {EstadoService} from '../../../_services/estado.service';
import {NivelesService} from '../../../_services/niveles.service';
import {Nivel} from '../../../_models/nivel';
import {PoliticaService} from '../../../_services/politica.service';
import {PoliticasDescartesVinculacionesService} from '../../../_services/politicas-descartes-vinculaciones.service';
import {PoliticasAlertasVinculacionesService} from '../../../_services/politicas-alertas-vinculaciones.service';
import {ActivatedRoute, Params} from '@angular/router';
import {PoliticaDescarteVinculacion} from '../../../_models/politica-descarte-vinculacion';
import {PoliticaVinculacion} from '../../../_models/politica-vinculacion';
import {PoliticaAlertaVinculacion} from '../../../_models/politica-alerta-vinculacion';
import {PerfilRiesgoService} from '../../../_services/perfil-riesgo.service';
import {EstructuraFisicaService} from '../../../_services/estructura-fisica.service';
import {PerfilRiegos} from '../../../_models/gestor-centralizado';
import {PerfilRiesgo} from '../../../_models/perfil-riesgo';
import {EstructuraFisica} from '../../../_models/estructura-fisica';
import {PoliticaPerfil} from '../../../_models/politica-perfil';
import {PoliticaOficina} from '../../../_models/politica-oficina';
import {PoliticaDescarteOficina} from '../../../_models/politica-descarte-oficina';
import {ConfirmationService} from 'primeng/api';
import {ModalidadService} from '../../../_services/modalidad.service';
import {ProductoService} from '../../../_services/producto.service';
import {Modalidad} from '../../../_models/modalidad';
import {Producto} from '../../../_models/producto';
import {PoliticaProducto} from '../../../_models/politica-producto';
import { FlujoVentaPasoService } from '../../../_services/flujo-venta-paso.service';
import {FlujoVentaPaso} from '../../../_models/flujo-venta-paso';
import {PoliticasPerfilService} from '../../../_services/politicas-perfil.service';
import {PoliticasDescarteOficinaService} from '../../../_services/politicas-descarte-oficina.service';
import {PoliticasOficinaService} from '../../../_services/politicas-oficina.service';
import {ProductoPoliticaAlertaService} from '../../../_services/producto-politica-alerta.service';
import {ProductoPoliticaAlerta} from '../../../_models/producto-politica-alerta';
import {PoliticasModalidadService} from '../../../_services/politicas-modalidad.service';
import {PoliticaModalidad} from '../../../_models/politica-modalidad';
import {PoliticasPlanteamientosPoliticasService} from '../../../_services/politicas-planteamientos-politicas.service';
import {sleep} from '../../../utils/utilidades';
import {DespensasService} from '../../../_services/despensas.service';
import {AutenticacionService} from '../../../_services/autenticacion.service';
import {PoliticasPerfilesRiesgo} from '../../../_models/politicas-perfiles-riesgo';
import {PoliticaPerfilesRiesgosService} from '../../../_services/politica-perfiles-riesgos.service';
import {PoliticaPlanteamientoPolitica} from '../../../_models/politica-planteamiento-politica';
import { PoliticaFlujoVenta } from '../../../_models/politica-flujo-venta';
import { PoliticasConfiguradasService } from '../../../_services/politicas-configuradas.service';
import { PoliticasMatrizVinculaciones } from "../../../_models/politica-configurada-matriz";
import { PoliticasFilaMatrizVinculaciones } from "../../../_models/politica-configurada-matriz-fila";
import {PoliticasRetanqueoProductosService} from '../../../_services/politicas-retanqueo-productos.service';
import {PoliticasRetanqueoProductos} from '../../../_models/politicas-retanqueo-productos';
import {ComunicationComponentsService} from '../../../_services/comunication-components.service';
import {PoliticasFlujoVentaPasosService} from "../../../_services/politicas-flujo-venta-pasos.service";
import {PoliticaFlujoVentaPaso} from "../../../_models/politica-flujo-venta-paso";
import {PoliticaConfigurada} from '../../../_models/politica-configurada';
import {Table} from "primeng/table";
import {RolesService} from '../../../_services/roles.service';
import {Rol} from '../../../_models/rol';
import {PoliticasRolesService} from '../../../_services/politicas-roles.service';
import {PoliticasRoles} from '../../../_models/politicas-roles';
import {SolicitudUcParentescoConvive} from '../../../_models/solicitud-uc-parentesco-convive';
import {PoliticaTipoProductoService} from '../../../_services/politica-tipo-producto.service';
import {PoliticaTipoProducto} from '../../../_models/politica-tipo-producto';

@Component({
  selector: "app-politcas-formulario",
  templateUrl: "./politcas-formulario.component.html",
  styleUrls: ["./politcas-formulario.component.scss"],
})
export class PolitcasFormularioComponent implements OnInit {

  @Input() politica: Politica;
  @Input() lisPoliticas: Politica[] = [];
  @Input() esDetalle: boolean = false;
  @Output() regresarAListado: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('tablePolcre') tablePolcre: Table;

  codExiste = false;
  guardando = false;
  carInformacionInicial = true;
  submitted = false;
  politicas: CentralizadaPoliticas = new CentralizadaPoliticas();
  formulario: FormGroup;


  politicaAnteriores = false;
  politicasCredito = false ;
  politicaPreselecta = false;
  politicaTipoAlerta = false;
  integracion = false;
  paso = false;

  valDesAle = false;


  listaCategoriasPoliticas: SelectItem[] = [];
  listaCategoriasPoliticasTodas: ListaItem[] = [];
  listaTiposProcesosCreditos: SelectItem[] = [];
  listaTiposProcesosCreditosTodas: ListaItem[] = [];
  tipoProcesoTradicional = true;
  listaVinculaciones: any;
  lisVinculaciones: SelectItem[] = [];
  lisTipoAlerta: SelectItem[] = [];

  lisEstados: SelectItem[] = [];
  lisCausales: SelectItem[] = [];
  lisNiveles: SelectItem[] = [];

  lisPerfiles: SelectItem[] = [];
  lisOficinas: SelectItem[] = [];
  lisNota: SelectItem[] = [];

  columnasOficinas: any[];
  columnasOficinasPolcre: any[];
  submittedOficinas = false;

  columnasProductos: any[];
  submittedProductos = false;

  listaDescarteOficinas: PoliticaDescarteOficina[] = [];
  listaPoliticaProducto: ProductoPoliticaAlerta[] = [];

  listOficinasPolcre: PoliticaOficina[] = [];
  listOficinasPolcreOriginal: PoliticaOficina[] = [];

  listaOficinas: EstructuraFisica[] = [];
  listaModalidades: Modalidad[] = [];
  lisModalidades: SelectItem[] = [];
  listaProductos: Producto[] = [];
  lisProductos: SelectItem[] = [];

  lisTiposPolitica: SelectItem[] = [];
  lisIntegracion: SelectItem[] = [];
  lisFlujoVentaPaso: SelectItem[] = [];

  listaTiposPolitica: ListaItem[] = [];

  valPerNota = false;
  valPolUniGen = false;
  valCodicionesPolitica = false;
  valConDesAle = false;

  lisPerfilesAplicables: PerfilRiesgo[] = [];
  activar = false;
  politicaPerfilRiesgo: PoliticasPerfilesRiesgo;

  politicaReglasParticipantes: boolean = false;
  politicaReglasTalanquera: boolean = false;
  formMatriz: boolean = false;
  listadoMatrices: any[];
  listadoMatricesModalidad: PoliticasMatrizVinculaciones[] = [];
  listadoMatricesTemporal : any[] = [];
  matrizGeneral: any = null;
  modalidadMatriz: string;

  listaProductosPoliticasRetanqueo: SelectItem[] = [];
  productosPoliticasRetanqueoTodas: PoliticasRetanqueoProductos[] = [];
  productosPoliticasRetanqueo: PoliticasRetanqueoProductos[] = [];
  listaProductosRetanqueo: Producto[] = [];
  columnasProductosRetanqueo: any[] = [];
  saveProductoRetanqueo: boolean = false;
  submittedProductosRetanqueo = false;
  lisPoliticasFlujoVentaPasosTodos: PoliticaFlujoVentaPaso[] = [];
  flujoVentaPasosPoliticas: PoliticaConfigurada[];
  banderaFvpPolitica: boolean;
  listaRespaldos: SelectItem[] = [];
  habilitarRespaldo: boolean = false;
  listaRolesTodos: Rol[];
  listaRoles:SelectItem[] = [];
  listaPoliticasRoles: PoliticasRoles[] = [];
  listaTiposProductosBancarios: ListaItem[] = [];
  selectTiposProductosBancarios: SelectItem[] = [];
  constructor(
    private lisServicio: ListaService,
    private nav: NavService,
    private fb: FormBuilder,
    private politicasVinculacionesService: PoliticasVinculacionesService,
    private politicaService: PoliticaService,
    private politicaDescarteVinculacionService: PoliticasDescartesVinculacionesService,
    private politicaAlertaVinculacionService: PoliticasAlertasVinculacionesService,
    private estServicio: EstadoService,
    private nivServicio: NivelesService,
    private route: ActivatedRoute,
    private perfilServicio: PerfilRiesgoService,
    private estructuraServicio: EstructuraFisicaService,
    private conServicio: ConfirmationService,
    private modalidadServices: ModalidadService,
    private productoServices: ProductoService,
    private flujoVentaServices: FlujoVentaPasoService,
    private politicasPerfilService: PoliticasPerfilService,
    private politicasDescarteOficinaService: PoliticasDescarteOficinaService,
    private politicasOficinaService: PoliticasOficinaService,
    private politicasModalidadService: PoliticasModalidadService,
    private proPoliticaServicio: ProductoPoliticaAlertaService,
    private politicasPlanteamientosPoliticasService: PoliticasPlanteamientosPoliticasService,
    private autServicio: AutenticacionService,
    private politicaPerfilRiesgoService: PoliticaPerfilesRiesgosService,
    private politicasConfiguradasService: PoliticasConfiguradasService,
    private flujoVentaPasoService: FlujoVentaPasoService,
    private politicasRetanqueoProductosService: PoliticasRetanqueoProductosService,
    private politicasFlujoVentaPasosService: PoliticasFlujoVentaPasosService,
    private rolesService: RolesService,
    private politicasRolesService: PoliticasRolesService,
    private politicaTipoProductoService: PoliticaTipoProductoService,
  ) {}

  ngOnInit() {
    if (this.politica) {
      this.politicas.politica = this.politica;
    }
    this.cargarInformacionInicial();
  }

  cargarInformacionInicial() {
    this.listaCategoriasPoliticas = [];
    this.politicas.listaVinculaciones = [];
    this.politicas.idsVinculaciones = [];
    this.politicas.vinculacion = [];
    forkJoin(
      this.lisServicio.getMasterDetails('ListasCategoriasPoliticas'),
      this.lisServicio.getMasterDetails('ListasTiposVinculaciones'),
      this.lisServicio.getMasterDetails('ListasTiposAlertas'),
      this.estServicio.listadoHabilitados(),
      this.lisServicio.getMasterDetails( 'ListasCausalesSolicitudes' ),
      this.nivServicio.listado(),
      this.perfilServicio.listadoHabilitados(),
      this.estructuraServicio.getAllEnabled(),
      this.modalidadServices.listadoModalidadesHabilitadas(),
      this.productoServices.listadoHabilitados(),
      this.lisServicio.getMasterDetails('ListasTiposEjecucionPolitica'),
      this.lisServicio.getMasterDetails('ListasIntegraciones'),
      this.flujoVentaServices.listadoHabilitados(),
      this.lisServicio.getMasterDetails('ListasTiposProcesosCreditos'),
      this.politicasConfiguradasService.list(),
      this.lisServicio.getMasterDetails('ListasRespaldos'),
      this.rolesService.listRoles(),
      this.lisServicio.getMasterDetails(Listas.LISTAS_TIPOS_PRODUCTOS_BANCARIOS),
    ).subscribe(
      async ([
        listaCategoriasPoliticas,
        listaVinculaciones,
        listaTipoAlertas,
         estados,  listaCausales,
        niveles,
        perfiles,
        oficinas,
        modalidades,
        productos,
         tiposPolitica,
         integraciones,
         flujoPaso,
        lisTiposProcesosCreditos,
        fvpPoliticas,
        listaRespaldos,
        roles,
        listaTiposProductos,
      ]) => {
        productos = productos.sort(function (a, b) {
          return a.orden - b.orden;
        });
        this.listaRolesTodos = roles;
        roles.map((x) => {
          if (x.indicadorHabilitado) {
            this.listaRoles.push({
              label: x.nombre,
              value: x.idRol,
            });
          }

        });

        this.listaCategoriasPoliticasTodas = listaCategoriasPoliticas;
        listaCategoriasPoliticas.map((x) => {
          this.listaCategoriasPoliticas.push({
            label: x.nombre,
            value: x.idLista,
          });
        });
        this.listaTiposProcesosCreditosTodas = lisTiposProcesosCreditos;
        this.listaTiposProcesosCreditosTodas.map( (x) => {
          this.listaTiposProcesosCreditos.push({
            label: x.nombre,
            value: x.idLista,
          });
        });
        this.listaVinculaciones = listaVinculaciones
        listaVinculaciones.map((x) => {
          this.lisVinculaciones.push( {
            label: x.nombre,
            value: x.idLista,
          } );
        });

        listaTipoAlertas.map((x) => {
          this.lisTipoAlerta.push( {
            label: x.nombre,
            value: x.idLista,
          } );
        });

        listaRespaldos.map((x) => {
          if ( x.indicadorHabilitado ) {
            this.listaRespaldos.push( {
              label: x.nombre,
              value: x.idLista,
            } );
          }
        });

        estados.map( ( s: Estado ) => {
          if (s.indicadorHabilitado && s.indicadorEstadoFinal) {
            this.lisEstados.push({label: s.nombre, value: s.idEstado});
          }
        } );

        listaCausales.map( ( s: ListaItem ) => {
          this.lisCausales.push( { label: s.nombre, value: s.idLista } );
        } );

        niveles.map( ( s: Nivel ) => {
          this.lisNiveles.push( { label: s.nombre, value: s.idNivel } );
        } );

        this.lisPerfilesAplicables = perfiles;
        this.cargarListado(this.lisPerfilesAplicables);

        oficinas.map( ( s: EstructuraFisica ) => {
          this.lisOficinas.push( { label: s.estructuraFisica, value: s.idEstructuraFisica } );
        } );

        this.listaTiposPolitica  = tiposPolitica;
        tiposPolitica.map( ( s: ListaItem ) => {
          this.lisTiposPolitica.push( { label: s.nombre, value: s.idLista } );
        } );

        integraciones.map( ( s: ListaItem ) => {
          this.lisIntegracion.push( { label: s.nombre, value: s.idLista } );
        } );

        flujoPaso.map( ( s: FlujoVentaPaso ) => {
          this.lisFlujoVentaPaso.push( { label: s.nombre, value: s.idFlujoVentaPaso } );
        } );

        this.listaTiposProductosBancarios = listaTiposProductos;
        this.selectTiposProductosBancarios = listaTiposProductos.map((e: ListaItem) => ({ label: e.nombre, value: e.idLista }));

        if (this.politica) {
          const politicasFlujoVentaPasos = await this.politicasFlujoVentaPasosService.obtenerPorId(this.politica.idPolitica).toPromise();
          if(politicasFlujoVentaPasos && politicasFlujoVentaPasos.length > 0) {
            this.lisPoliticasFlujoVentaPasosTodos = politicasFlujoVentaPasos;
          }
        }

        this.listaOficinas = oficinas;

        for(let i = 1; i < 6; i++){
          this.lisNota.push( { label: i.toString(), value: i } );
        }

        this.politicas.listaVinculaciones = listaVinculaciones;
        this.politicas.listaCategoriasPoliticas = listaCategoriasPoliticas;

        this.listaModalidades = modalidades;
        this.validacionMatriz();
        this.listaProductosRetanqueo = productos;
        this.listaProductos = productos;
        productos.map( ( s: Producto ) => {
          this.lisProductos.push( { label: s.nombre, value: s.idProducto } );
          this.listaProductosPoliticasRetanqueo.push( { label: s.nombre, value: s.idProducto } );
        } );

        this.flujoVentaPasosPoliticas = fvpPoliticas;

        this.columnasOficinas = [
          {
            field: "codigo", header: this.nav.buscarMensaje("POLITICAS.LBL_OFICINA"), sort: false,
          }
        ];

        this.columnasOficinasPolcre = [
          {field: "codigo", header: this.nav.buscarMensaje("POLITICAS.LBL_CODIGO"), sort: false,},
          {field: "estructura", header: this.nav.buscarMensaje("POLITICAS.LBL_OFICINA"), sort: false,}
        ];

        if ( !this.esDetalle ) {
          this.columnasOficinas.push( { field: 'det', header: this.nav.buscarMensaje( 'LBL_ACCIONES' ), sort: false } );
          this.columnasOficinasPolcre.push( { field: 'det', header: this.nav.buscarMensaje( 'LBL_ACCIONES' ), sort: false } );
        }

        this.columnasProductos = [
          { field: "codigo", header: this.nav.buscarMensaje("POLITICAS.LBL_CODIGO"), sort: false, },
          { field: "producto", header: this.nav.buscarMensaje("POLITICAS.LBL_PRODUCTO"), sort: false, },
          { field: "modalidad", header: this.nav.buscarMensaje("POLITICAS.LBL_MODALIDAD"), sort: false, },

        ];

        this.columnasProductosRetanqueo = [
          { field: "codigo", header: this.nav.buscarMensaje("POLITICAS.LBL_CODIGO"), sort: false, },
          { field: "producto", header: this.nav.buscarMensaje("POLITICAS.LBL_PRODUCTO"), sort: false, },
          { field: "productoModalidad", header: this.nav.buscarMensaje("POLITICAS.LBL_MODALIDAD"), sort: false, },

        ];
        if ( !this.esDetalle ) {
          this.columnasProductos.push( { field: 'det', header: this.nav.buscarMensaje( 'LBL_ACCIONES' ), sort: false } );
        }
        if ( !this.esDetalle ) {
          this.columnasProductosRetanqueo.push( { field: 'det', header: this.nav.buscarMensaje( 'LBL_ACCIONES' ), sort: false } );
        }
        this.cargarPoliticas();
        this.validarSegunPerfil(true);

      }
    );
  }

  cargarListado(perfil: any) {
    this.lisPerfiles = [];
    perfil.map((s: PerfilRiesgo) => {
      if (!this.activar) {
        this.lisPerfiles.push({label: s.nombreRiesgo, value: s.idPerfilRiesgo});
      } else {
        this.lisPerfiles.push({label: `${s.codigo}-${s.nombreRiesgo}`, value: s.idPerfilRiesgo });
      }
    });
  }

  validarSegunPerfil(emitir: boolean) {
    if (emitir) {
      this.activar = this.politicas.politica ? this.politicas.politica.indicadorPerfilRiesgo : false;
      return;
    } else {
      this.activar = this.f.indicadorPerfilRiesgo.value;
      this.politicas.politica.indicadorPerfilRiesgo = this.f.indicadorPerfilRiesgo.value;
    }
    if (this.activar) {
      this.cargarListado(this.lisPerfilesAplicables);
      this.setRequeridos();
    } else {
      this.cargarListado(this.lisPerfilesAplicables);
      this.setRequeridos();
      this.politicas.politica.indicadorPerfilRiesgo = false;
      this.politicas.listPoliticasPerfilesRiesgos = [];
    }
    this.f.idPerfilRiesgo.setValue(null);
  }

  cargarPoliticas(){

    if (this.politica) {
      forkJoin(
        this.politicasVinculacionesService.listadoIdPolitica(this.politica.idPolitica),
        this.politicaDescarteVinculacionService.listadoIdPolitica(this.politica.idPolitica),
        this.politicaAlertaVinculacionService.listadoIdPolitica(this.politica.idPolitica),
        this.politicasPerfilService.listadoIdPolitica(this.politica.idPolitica),
        this.politicasDescarteOficinaService.listadoIdPolitica(this.politica.idPolitica),
        this.politicasOficinaService.listadoIdPolitica(this.politica.idPolitica),
        this.politicasModalidadService.listadoIdPolitica(this.politica.idPolitica),
        this.proPoliticaServicio.listadoPorPolitica(this.politica.idPolitica),
        this.politicaPerfilRiesgoService.listadoPorPolitica(this.politica.idPolitica),
        this.politicasRetanqueoProductosService.listadoPorPolitica(this.politica.idPolitica),
        this.politicasRolesService.obtenerPorId(this.politica.idPolitica),
        this.politicaTipoProductoService.getByIdPolitica(this.politica.idPolitica),
      ).subscribe( ([vinculaciones,  descarteVinculaciones, alertaVinculaciones,
                            perfiles, descartesOficinas,  oficinas,
                            modalidades,
                          politicaProducto, polPerfilRiesgo, politicasRetanqueoProductos, politicaRoles, politicaTiposProductos
                          ]) => {

        politicaRoles.forEach(x => {
          if (x.indicadorHabilitado) {
            this.listaPoliticasRoles.push(x);
          }
        });

        let roles = null;
        politicaRoles.map(s => {
          if(s.indicadorHabilitado){
            if ( roles) {
              roles = roles + ", " + s.rol;
            } else {
              roles = s.rol;
            }
          }
        });
        this.politica.roles = roles;
        let vinculacion ="";
        vinculaciones.map(s => {
          if(s.indicadorHabilitado){
            if ( vinculacion) {
              vinculacion = vinculacion + ", " + s.vinculacion;
            } else {
              vinculacion = s.vinculacion;
            }
          }
        });

        let descarteVinculacion ="";
        descarteVinculaciones.map(s => {
          if(s.indicadorHabilitado){
            if ( descarteVinculacion) {
              descarteVinculacion = descarteVinculacion + ", " + s.vinculacion;
            } else {
              descarteVinculacion = s.vinculacion;
            }
          }
        });

        let alertaVinculacion ="";
        alertaVinculaciones.map(s => {
          if(s.indicadorHabilitado){
            if ( alertaVinculacion) {
              alertaVinculacion = alertaVinculacion + ", " + s.vinculacion;
            } else {
              alertaVinculacion = s.vinculacion;
            }
          }
        });

        let perfile ="";
        perfiles.map(s => {
          if(s.indicadorHabilitado){
            if ( perfile) {
              perfile = perfile + ", " + s.perfil;
            } else {
              perfile = s.perfil;
            }
          }
        });

        let oficina ="";
        oficinas.map(s => {
          if(s.indicadorHabilitado){
            if ( oficina) {
              oficina = oficina + ", " + s.estructura;
            } else {
              oficina = s.estructura;
            }
          }
        });

        let modalidad ="";
        modalidades.map(s => {
          if(s.indicadorHabilitado){
            if ( modalidad) {
              modalidad = modalidad + ", " + s.modalidad;
            } else {
              modalidad = s.modalidad;
            }
          }
        });

        let perfilRiesgo = "";
        polPerfilRiesgo.map(s => {
          if (s.indicadorHabilitado) {
            if (perfilRiesgo) {
              perfilRiesgo = perfilRiesgo + ", " + s.perfilRiesgo;
            } else {
              perfilRiesgo = s.perfilRiesgo;
            }
          }
        });

        politicasRetanqueoProductos.map(s => {
          if (s.indicadorHabilitado) {
            this.productosPoliticasRetanqueo.push(s);
            this.productosPoliticasRetanqueoTodas.push(s);
          }
        });

        this.politica.tipoProducto = politicaTiposProductos.filter(e => e.indicadorHabilitado).map(e => e.tipoProductoBancario).join(", ");
        this.politicas.tipoProducto = politicaTiposProductos;
        this.politicas.vinculacion = vinculaciones;
        this.politicas.descartesVinculaciones = descarteVinculaciones;
        this.politicas.alertaVinculacion = alertaVinculaciones;
        this.politicas.perfiles = perfiles;
        this.politicas.descarteOficinas = descartesOficinas;
        this.politicas.oficinas = oficinas;
        this.listOficinasPolcre = oficinas.filter(x => x.indicadorHabilitado);
        this.listOficinasPolcre.forEach(e => {
          const buscar = this.listaOficinas.find(s => s.idEstructuraFisica === e.idEstructuraFisica);
          if (!!buscar) {
            e.codigo = buscar.codigo;
          }
        });
        this.listOficinasPolcreOriginal = oficinas.filter(x => x.indicadorHabilitado);
        this.listaDescarteOficinas = descartesOficinas.filter(s => s.indicadorHabilitado);
        this.politicas.productos = politicaProducto;
        this.politicas.modalidades = modalidades;
        this.listaPoliticaProducto = politicaProducto.filter(s => s.indicadorHabilitado);
        this.politicas.listPoliticasPerfilesRiesgos = polPerfilRiesgo.filter(s => s.indicadorHabilitado);

        this.politica.vinculaciones = vinculacion;
        this.politica.descarteVinculacion = descarteVinculacion;
        this.politica.alertaVinculacion = alertaVinculacion;
        this.politica.perfiles = perfile;
        this.politica.oficinas = oficina;
        this.politica.modalidad = modalidad;
        let pasos: string = '';
        this.lisPoliticasFlujoVentaPasosTodos.map(dato => {
          if(dato.indicadorHabilitado){
            pasos += dato.flujo + ', ';
          }
        });
        if (pasos) {
          pasos = pasos.substring(0, pasos.length - 2);
          this.politica.flujo = pasos;
        }
        this.politicas.politicasPerfilRiesgo.perfilRiesgo = perfilRiesgo;
        this.politicas.politica = this.politica;

        this.cargaProducto();
        this.cargaProductoPoliticaRetanqueo();
        this.cargarFormulario();
        this.validarCampos();
        this.tiposEjecucion();
        this.validacionesDescartes();
        this.validacionesAlertas();
        this.validarTipoProceso();
        if (this.politica.indicadorAlerta) {
          this.validacionesAlertasExcepcion();
        }
        if(this.politica.indicadorPoliticaModalidad || this.politica.indicadorPoliticaProducto || this.politica.indicadorPoliticaGlobal){
          if ( this.politica.indicadorPoliticaModalidad) {
            this.validarTipoPolitica('Modalidad');
          } else if ( this.politica.indicadorPoliticaProducto) {
            this.validarTipoPolitica( 'Producto');
          }else {
            this.validarTipoPolitica( 'Global');
          }
        }
        this.carInformacionInicial = false;
      });
    } else {
      this.listaCategoriasPoliticas = [];
      this.listaCategoriasPoliticasTodas.map( ( s: ListaItem ) => {
        if ( s.codigo !== CodigosPoliticas.PoliticaAnteriores) {
          this.listaCategoriasPoliticas.push( { label: s.nombre, value: s.idLista } );
        }
      } );
      this.cargarFormulario();
      this.validarTipoProceso();
      this.carInformacionInicial = false;
    }



  }

  cargarFormulario() {

    const vinculacion = [];
    if(this.politicas.vinculacion.length > 0) {
      this.politicas.vinculacion.forEach( e => {
        if ( e.indicadorHabilitado ) {
          vinculacion.push( e.idVinculacion );
        }
      } );
    }

    const vinculacionDescarta = [];
    if(this.politicas.descartesVinculaciones.length > 0) {
      this.politicas.descartesVinculaciones.forEach( e => {
        if ( e.indicadorHabilitado ) {
          vinculacionDescarta.push( e.idVinculacion );
        }
      } );
    }

    const vinculacionAlerta = [];
    if(this.politicas.alertaVinculacion.length > 0) {
      this.politicas.alertaVinculacion.forEach( e => {
        if ( e.indicadorHabilitado ) {
          vinculacionAlerta.push( e.idVinculacion );
        }
      } );
    }

    const perfiles = [];
    if(this.politicas.perfiles.length > 0) {
      this.politicas.perfiles.forEach( e => {
        if ( e.indicadorHabilitado ) {
          perfiles.push( e.idPerfilRiesgo );
        }
      } );
    }

    const oficinas = [];
    if(this.politicas.oficinas.length > 0) {
      this.politicas.oficinas.forEach( e => {
        if ( e.indicadorHabilitado ) {
          oficinas.push( e.idEstructuraFisica );
        }
      } );
    }



    const modalidades =[];
    if(this.politicas.modalidades.length > 0) {
      this.politicas.modalidades.forEach( e => {
        if ( e.indicadorHabilitado ) {
          modalidades.push( e.idModalidadCredito );
        }
      } );
    }

    const perfilesRiesgos = [];
    if (this.politicas.listPoliticasPerfilesRiesgos.length > 0 && this.activar) {
      this.politicas.listPoliticasPerfilesRiesgos.forEach( e => {
        if (e.indicadorHabilitado) {
          perfilesRiesgos.push(e.idPerfilRiesgo);
        }
      });
    } else {
      this.politicas.listPoliticasPerfilesRiesgos = [];
    }
    const roles = [];
    this.listaRolesTodos.forEach( e => {
      if ( e.indicadorHabilitado && this.listaPoliticasRoles.find(p => p.idRol === e.idRol)) {
        roles.push( e.idRol );
      }
    } );

    const tipoProducto: string[] = this.politicas.tipoProducto.filter(e => e.indicadorHabilitado).map(e => e.idTipoProductoBancario);

    this.formulario = this.fb.group({
      idPolitica: [{
        value: this.politica ? this.politica.idPolitica : null,
        disabled: this.esDetalle
      }],
      codigo: [ {
        value: this.politica ? this.politica.codigo : null,
        disabled: this.esDetalle
      }, [Validators.required]  ],
      nombre: [  {
        value: this.politica ? this.politica.nombre  : null,
        disabled: this.esDetalle
      }, [Validators.required] ],
      idCategoriaPolitica: [ {
        value: this.politica  ? this.politica.idCategoriaPolitica : null,
        disabled: this.esDetalle
      }],
      idTipoAlerta: [ {
        value: this.politica  ? this.politica.idTipoAlerta : null,
        disabled: this.esDetalle
      } ],
      idNivel: [  {
        value: this.politica  ? this.politica.idNivel : null,
        disabled: this.esDetalle
      } ],
      idEstado: [  {
        value: this.politica ? this.politica.idEstado : null,
        disabled: this.esDetalle
      }],
      idCausal: [ {
        value: this.politica ? this.politica.idCausal : null,
        disabled: this.esDetalle
      } ],
      idIdentificacionPolitica: [ {
        value: this.politica ? this.politica.idIdentificacionPolitica : null,
        disabled: this.esDetalle
      } ],

      idIntegracion: [ {
        value: this.politica ? this.politica.idIntegracion : null,
        disabled: this.esDetalle
      } ],
      idPaso: [ {
        value: (this.politica && this.lisPoliticasFlujoVentaPasosTodos.length > 0) ? this.lisPoliticasFlujoVentaPasosTodos.filter(dato => dato.indicadorHabilitado).map(x => {return x.idFlujoVentaPaso}) : null,
        disabled: this.esDetalle
      } ],
      idRol: [ {
        value: roles,
        disabled: this.esDetalle
      } ],
      idRespaldo: [ {
        value: this.politica ? this.politica.idRespaldo : null,
        disabled: this.esDetalle
      }],
      descripcion: [ {
        value: this.politica  ? this.politica.descripcion : null,
        disabled: this.esDetalle
      } ],
      definicion: [ {
        value: this.politica  ? this.politica.definicion : null,
        disabled: this.esDetalle
      } ],
      nota: [ {
        value: this.politica  ? this.politica.nota : null,
        disabled: this.esDetalle
      } ],
      respuesta: [ {
        value: this.politica  ? this.politica.respuesta : null,
        disabled: this.esDetalle
      } ],
      ordenEjecucion: [ {
        value: this.politica  ? this.politica.ordenEjecucion : null,
        disabled: this.esDetalle
      } ],
      idsVinculaciones: [ {
        value: vinculacion,
        disabled: this.esDetalle
      }, [Validators.required] ],
      idVinculacionDescarta: [ {
        value: vinculacionDescarta,
        disabled: this.esDetalle
      } ],
      idVinculacionAlerta: [ {
        value: vinculacionAlerta,
        disabled: this.esDetalle
      } ],
      idPerfil: [ {
        value: perfiles,
        disabled: this.esDetalle
      } ],
      idOficinas: [ {
        value: oficinas,
        disabled: this.esDetalle
      } ],
      idModalidadCredito: [ {
        value: modalidades,
        disabled: this.esDetalle
      } ],
      idProducto: [ {
        value: null,
        disabled: this.esDetalle
      }],
      idoficinasDescarte: [ {
        value: null,
        disabled: this.esDetalle
      }, [] ],
      idOficinasPolcre: [ {
        value: null,
        disabled: this.esDetalle
      }, [] ],
      indicadorDescarta: [ {
        value: this.politica  ? this.politica.indicadorDescarta : false,
        disabled: this.esDetalle
      } ],
      indicadorAlerta: [ {
        value: this.politica  ? this.politica.indicadorAlerta : false,
        disabled: this.esDetalle
      } ],
      indicadorExcepcion: [ {
        value: this.politica  ? this.politica.indicadorExcepcion : false,
        disabled: this.esDetalle
      } ],
      indicadorManejaAdjunto: [ {
        value: this.politica  ? this.politica.indicadorManejaAdjunto : false,
        disabled: this.esDetalle
      } ],
      indicadorReglaRetanqueo: [ {
        value: this.politica  ? this.politica.indicadorReglaRetanqueo : false,
        disabled: this.esDetalle
      } ],
      indicadorEjecucionIndividual: [ {
        value: this.politica  ? this.politica.indicadorEjecucionIndividual : false,
        disabled: this.esDetalle
      } ],
      indicadorRenovacion: [ {
        value: this.politica  ? this.politica.indicadorRenovacion : false,
        disabled: this.esDetalle
      } ],
      indicadorNuevo: [ {
        value: this.politica  ? this.politica.indicadorNuevo : false,
        disabled: this.esDetalle
      } ],
      indicadorHabilitado: [ {
        value: this.politica  ? this.politica.indicadorHabilitado : false,
        disabled: this.esDetalle
      } ],
      indicadorOficina: [ {
        value: this.politica  ? this.politica.indicadorOficina : false,
        disabled: this.esDetalle
      } ],
      indicadorPoliticaGlobal: [ {
        value: this.politica  ? this.politica.indicadorPoliticaGlobal : false,
        disabled: this.esDetalle
      } ],
      indicadorPoliticaModalidad: [ {
        value: this.politica  ? this.politica.indicadorPoliticaModalidad : false,
        disabled: this.esDetalle
      } ],
      indicadorPoliticaProducto: [ {
        value: this.politica  ? this.politica.indicadorPoliticaProducto : false,
        disabled: this.esDetalle
      } ],
      indicadorUsoPolitica: [ {
        value: this.politica ? this.politica.indicadorPoliticaProducto ? 'Producto' :
          this.politica.indicadorPoliticaModalidad ? 'Modalidad' : this.politica.indicadorPoliticaGlobal ? 'Global' :'' :'',
        disabled: this.esDetalle
      } ],
      indicadorAplicaRol: [ {
        value: this.politica  ? this.politica.indicadorAplicaRol : false,
        disabled: this.esDetalle
      } ],
      indicadorDenegacionAutomatica: [ {
        value: this.politica  ? this.politica.indicadorDenegacionAutomatica : false,
        disabled: this.esDetalle
      } ],
      idPerfilRiesgo: [{
        value: perfilesRiesgos,
        disabled: this.esDetalle
      }],
      indicadorTasaMaxima: [ {
        value: this.politica ? this.politica.indicadorTasaMaxima : false,
        disabled: this.esDetalle
      }],
      indicadorPerfilRiesgo: [ {
        value: this.politica ? this.politica.indicadorPerfilRiesgo : false,
        disabled: this.esDetalle
      }],
      modalidadMatriz: [ {
        value: null,
        disabled: this.esDetalle
      } ],
      idPoliticaRetanqueoProducto: [ {
        value: null,
        disabled: this.esDetalle
      }],
      indicadorPlataformaDigital: [ {
        value: this.politica  ? this.politica.indicadorPlataformaDigital : false,
        disabled: this.esDetalle
      }],
      idsTipoProducto: [{
        value: tipoProducto,
        disabled: this.esDetalle
      }, [Validators.required]],
    });

    this.validarRequerirRespaldo();

  }

  get f() {
    return this.formulario.controls;
  }

  validarCodigo() {
    this.codExiste = this.lisPoliticas.find(  (x) => x.codigo === this.f.codigo.value ) ? true : false;
    this.validarPoliticaReglasParticipantes()
    this.validarPoliticaReglasTalanquera()
  }

  regresar(dirty: boolean) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.nav.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'oficinas',
        accept: async () => {
          this.regresarAListado.emit(true);
        },
        reject: () => {
        }
      } );
    } else {
      this.regresarAListado.emit(true);
    }

  }

  validarCampos() {
      const d = this.politicas.listaCategoriasPoliticas.find( x => x.idLista === this.f.idCategoriaPolitica.value );
      this.politicaAnteriores = false;
      this.politicasCredito = false ;
      this.politicaPreselecta = false;
      this.politicaTipoAlerta = false;
      this.seterarCampos();
      this.validarPoliticaReglasParticipantes()
      this.validarPoliticaReglasTalanquera()
      if ( d.codigo === CodigosPoliticas.PoliticaAnteriores) {
        this.politicaAnteriores = true;
        this.f.indicadorPerfilRiesgo.setValue(null);
        this.f.idTipoAlerta.setValidators( [ Validators.required ] );
        this.f.idTipoAlerta.updateValueAndValidity();
        this.f.descripcion.setValidators( [ Validators.required ] );
        this.f.descripcion.updateValueAndValidity();
        this.f.idIdentificacionPolitica.setValidators( null );
        this.f.idOficinas.updateValueAndValidity();
      } else if ( d.codigo === CodigosPoliticas.PoliticaPreselecta) {
        this.politicaPreselecta = true;
        this.f.indicadorPerfilRiesgo.setValue(null);
        this.f.descripcion.setValidators( [ Validators.required ] );
        this.f.descripcion.updateValueAndValidity();
        this.f.respuesta.setValidators( [ Validators.required ] );
        this.f.respuesta.updateValueAndValidity();
        this.f.idIdentificacionPolitica.setValidators( null );
        this.f.idOficinas.updateValueAndValidity();
      } else if ( d.codigo === CodigosPoliticas.PoliticasCredito) {
        this.politicasCredito = true;
        this.cargaOficinasPolcre();
        this.f.descripcion.setValidators( [ Validators.required ] );
        this.f.descripcion.updateValueAndValidity();
        this.f.idIdentificacionPolitica.setValidators( [ Validators.required ] );
        this.f.idIdentificacionPolitica.updateValueAndValidity();
      } else if ( d.codigo === CodigosPoliticas.PoliticaTipoAlerta) {
        this.politicaTipoAlerta = true;
        this.f.indicadorPerfilRiesgo.setValue(null);
        this.f.idIdentificacionPolitica.setValidators( null );
        this.f.idOficinas.updateValueAndValidity();
        if (!this.politicaReglasParticipantes && !this.politicaReglasTalanquera) {
          this.f.idTipoAlerta.setValidators( [ Validators.required ] );
          this.f.idTipoAlerta.updateValueAndValidity();
          this.f.idOficinas.setValidators( [ Validators.required ] );
          this.f.idOficinas.updateValueAndValidity();
        }
        this.f.descripcion.setValidators( [ Validators.required ] );
        this.f.descripcion.updateValueAndValidity();
      }
  }

  seterarCampos(){
    this.f.idTipoAlerta.setValidators( null);
    this.f.idTipoAlerta.updateValueAndValidity();
    this.f.descripcion.setValidators( null );
    this.f.descripcion.updateValueAndValidity();
    this.f.idEstado.setValidators( null );
    this.f.idEstado.updateValueAndValidity();
    this.f.idCausal.setValidators( null );
    this.f.idCausal.updateValueAndValidity();
    this.f.idVinculacionDescarta.setValidators( null );
    this.f.idVinculacionDescarta.updateValueAndValidity();
    this.f.idNivel.setValidators( null );
    this.f.idNivel.updateValueAndValidity();
    this.f.definicion.setValidators( null );
    this.f.definicion.updateValueAndValidity();
    this.f.idPerfil.setValidators( null );
    this.f.idPerfil.updateValueAndValidity();
    this.f.idOficinas.setValidators(null );
    this.f.idOficinas.updateValueAndValidity();
    this.f.nota.setValidators( null );
    this.f.nota.updateValueAndValidity();
    this.f.respuesta.setValidators( null );
    this.f.respuesta.updateValueAndValidity();

    this.f.idIdentificacionPolitica.setValidators( null );
    this.f.idIdentificacionPolitica.updateValueAndValidity();
    this.f.idIntegracion.setValidators( null );
    this.f.idIntegracion.updateValueAndValidity();
    this.f.idPaso.setValidators( null );
    this.f.idPaso.updateValueAndValidity();

  }

  validacionesDescartes(){

    if (this.f.indicadorDescarta.value){
      this.f.idEstado.setValidators( [ Validators.required ] );
      this.f.idEstado.updateValueAndValidity();
      this.f.idCausal.setValidators( [ Validators.required ] );
      this.f.idCausal.updateValueAndValidity();
      this.f.idVinculacionDescarta.setValidators( [ Validators.required ] );
      this.f.idVinculacionDescarta.updateValueAndValidity();
      this.valConDesAle = false;
    } else {
      this.f.idEstado.setValidators( null );
      this.f.idEstado.updateValueAndValidity();
      this.f.idCausal.setValidators( null );
      this.f.idCausal.updateValueAndValidity();
      this.f.idVinculacionDescarta.setValidators( null );
      this.f.idVinculacionDescarta.updateValueAndValidity();
      if (!this.politicasCredito) {
        this.f.indicadorOficina.setValue(false);
      }
    }
  }

  validacionesAlertas(){

    if (this.f.indicadorAlerta.value){
      this.f.idVinculacionAlerta.setValidators( [ Validators.required ] );
      this.f.idVinculacionAlerta.updateValueAndValidity();
      this.valConDesAle = false;
    } else {
      this.f.idVinculacionAlerta.setValidators( null );
      this.f.idVinculacionAlerta.updateValueAndValidity();
      this.f.idNivel.setValidators( null );
      this.f.idNivel.updateValueAndValidity();
      this.f.definicion.setValidators( null );
      this.f.definicion.updateValueAndValidity();
      this.f.indicadorExcepcion.setValue(false);
      this.validacionesAlertasExcepcion();
    }
  }

  validacionesAlertasExcepcion(){
    if (this.f.indicadorExcepcion.value){
      this.f.idNivel.setValidators( [ Validators.required ] );
      this.f.idNivel.updateValueAndValidity();
      this.f.definicion.setValidators( [ Validators.required ] );
      this.f.definicion.updateValueAndValidity();
    } else {
      this.f.idNivel.setValidators( null );
      this.f.idNivel.updateValueAndValidity();
      this.f.definicion.setValidators( null );
      this.f.definicion.updateValueAndValidity();
      this.f.indicadorManejaAdjunto.setValue(false);
      this.f.indicadorManejaAdjunto.setValidators(null);
      this.f.indicadorManejaAdjunto.updateValueAndValidity();
      this.f.idRespaldo.setValue( null );
      this.f.idRespaldo.setValidators(null);
      this.f.idRespaldo.updateValueAndValidity();
      this.f.indicadorAplicaRol.setValue(false);
      this.f.indicadorAplicaRol.setValidators(null);
      this.f.indicadorAplicaRol.updateValueAndValidity();
      this.f.idRol.setValue( null );
      this.f.idRol.setValidators(null);
      this.f.idRol.updateValueAndValidity();
      this.habilitarRespaldo = false;
    }
  }

  setRequeridos() {
    if (this.activar) {
      this.f.idPerfilRiesgo.setValidators( [ Validators.required ] );
      this.f.idPerfilRiesgo.updateValueAndValidity();
    } else {
      this.f.idPerfilRiesgo.setValidators(null);
      this.f.idPerfilRiesgo.updateValueAndValidity();
    }
  }

  matchPerfilesSeleccionados(event?: any) {
    this.setRequeridos();
    const formulario = this.formulario.value;
    formulario.idPerfilRiesgo.map( sud => {
      let temp = {} as PoliticasPerfilesRiesgo;
      temp.idPerfilRiesgo = sud;
      temp.idPolitica = this.politicas.politica ? this.politicas.politica.idPolitica : temp.idPolitica;
      temp.indicadorHabilitado = true;
      const existe = this.politicas.listPoliticasPerfilesRiesgos.find( x => x.idPerfilRiesgo === temp.idPerfilRiesgo);
      if(existe) {
        temp.idPoliticaPerfilRiesgo = existe.idPoliticaPerfilRiesgo;
      }
      this.politicas.listPoliticasPerfilesRiesgos.push(temp);
    });
    this.politicas.listPoliticasPerfilesRiesgos.forEach(e => {
      if ( e.idPoliticaPerfilRiesgo && e.indicadorHabilitado && !formulario.idPerfilRiesgo.find( y => y === e.idPerfilRiesgo ) ) {
        e.indicadorHabilitado = false;
        this.politicas.listPoliticasPerfilesRiesgos.push( e );
    }
    });
  }

  validarTipoCredito() {
    let cumple: boolean;
    const formulario = this.formulario.value;
    if (!formulario.indicadorNuevo && !formulario.indicadorRenovacion && !this.politicaReglasParticipantes && !this.politicaReglasTalanquera) {
      cumple = false;
      this.nav.setMesage( 0, {
        severity: 'info', summary: this.nav.buscarMensaje('LBL_INFORMACION'),
        detail: this.nav.buscarMensaje('POLITICAS.LBL_INDICADORREQUERIDO')
      });
    } else {
      cumple = true;
    }
    return cumple;
  }

  async onSubmit(salir: boolean = true) {
    if (!this.formulario.valid) {
      const invalidFields = this.findInvalidControls();
      console.log('Controles inválidos:', invalidFields);
    }
    this.submitted = true;
    if (this.politicasCredito && this.f.indicadorOficina.value && this.listOficinasPolcre.length === 0) {
      this.nav.setMesage( 0, {
        severity: 'info', summary: this.nav.buscarMensaje('LBL_INFORMACION'),
        detail: this.nav.buscarMensaje('POLITICAS.MSG_LISOFICINAS')
      });
      return;
    }
    if (this.politicasCredito && Array.isArray(this.f.idRol.value) && this.f.idRol.value.length === 0 && this.f.indicadorAplicaRol.value) {
        await this.validarRequeirirRoles();
    }
    if ( this.formulario.valid && !this.codExiste && this.validarTipoCredito()) {
      this.guardando = true;
      this.valDesAle = false;
      this.valPolUniGen = false;
      this.valCodicionesPolitica = false;
      this.valConDesAle = false;
      const formulario = this.formulario.value;
      const d = this.politicas.listaCategoriasPoliticas.find( x => x.idLista === this.f.idCategoriaPolitica.value );
      const tempTipoVinculacion: PoliticaVinculacion[] = [];
      const tempDescarteVinculacion: PoliticaDescarteVinculacion[] = [];
      const tempAlertaVinculacion: PoliticaAlertaVinculacion[] = [];
      const tempPerfil: PoliticaPerfil[] = [];
      let tempOficina: PoliticaOficina[] = [];
      let tempDescarteOficina: PoliticaDescarteOficina[] = [];
      const tempModalidad: PoliticaModalidad[] = [];
      let tempProductoPolitica: ProductoPoliticaAlerta[] = [];
      const tempPoliticaGlobal: PoliticaFlujoVenta[] = [];
      const tempTipoProducto: PoliticaTipoProducto[] = [];

      if ( formulario.idsVinculaciones ) {
        formulario.idsVinculaciones.map( sud => {
          let temp = {} as PoliticaVinculacion;
          const d = this.politicas.listaVinculaciones.find( x => x.idLista === sud );
          temp.idVinculacion = sud;
          temp.idPolitica = this.politicas.politica.idPolitica;
          temp.indicadorHabilitado = true;
          if (d) {
            temp.vinculacion = d.nombre;
          }
          const existe = this.politicas.vinculacion.find( x => x.idVinculacion === temp.idVinculacion);
          if(existe) {
            temp.idPoliticaVinculacion = existe.idPoliticaVinculacion;
          }
          tempTipoVinculacion.push(temp);
        });
        this.politicas.vinculacion.forEach( e => {
          if ( e.idPoliticaVinculacion &&  e.indicadorHabilitado && !formulario.idsVinculaciones.find( y => y === e.idVinculacion ) ) {
            e.indicadorHabilitado = false;
            tempTipoVinculacion.push( e );
          }
        } );
      }

      if(formulario.idsTipoProducto) {
        formulario.idsTipoProducto.forEach((idTipoProducto: string) => {
          let temp: PoliticaTipoProducto = {} as PoliticaTipoProducto;
          temp.idTipoProductoBancario = idTipoProducto;
          temp.idPolitica = this.politicas.politica.idPolitica;
          temp.indicadorHabilitado = true;

          const politicaTipoProducto: PoliticaTipoProducto = this.politicas.tipoProducto.find(e => e.idTipoProductoBancario === idTipoProducto);
          if(politicaTipoProducto) {
            temp.idPoliticaTipoProductoBancario = politicaTipoProducto.idPoliticaTipoProductoBancario;
          }

          tempTipoProducto.push(temp);
        });

        this.politicas.tipoProducto.forEach(e => {
          if(e.idTipoProductoBancario && e.indicadorHabilitado && !formulario.idsTipoProducto.includes(e.idTipoProductoBancario)) {
            e.indicadorHabilitado = false;
            tempTipoProducto.push(e);
          }
        });
      }

      if ( formulario.idVinculacionDescarta ) {
        formulario.idVinculacionDescarta.map( sud => {
          let temp = {} as PoliticaDescarteVinculacion;

          const d = this.politicas.listaVinculaciones.find( x => x.idLista === sud );
          temp.idVinculacion = sud;
          temp.idPolitica = this.politicas.politica.idPolitica;
          temp.indicadorHabilitado = true;

          const existe = this.politicas.descartesVinculaciones.find( x => x.idVinculacion === temp.idVinculacion);
          if(existe) {
            temp.idPoliticaDescarteVinculacion = existe.idPoliticaDescarteVinculacion;
          }
          tempDescarteVinculacion.push(temp);
        });
        this.politicas.descartesVinculaciones.forEach( e => {
          if ( e.idPoliticaDescarteVinculacion &&  e.indicadorHabilitado && !formulario.idVinculacionDescarta.find( y => y === e.idVinculacion ) ) {
            e.indicadorHabilitado = false;
            tempDescarteVinculacion.push( e );
          }
        } );
      }

      if ( formulario.idVinculacionAlerta ) {
        formulario.idVinculacionAlerta.map( sud => {
          let temp = {} as PoliticaAlertaVinculacion;

          const d = this.politicas.listaVinculaciones.find( x => x.idLista === sud );
          temp.idVinculacion = sud;
          temp.idPolitica = this.politicas.politica.idPolitica;
          temp.indicadorHabilitado = true;

          const existe = this.politicas.alertaVinculacion.find( x => x.idVinculacion === temp.idVinculacion);
          if(existe) {
            temp.idPoliticaAlertaVinculacion = existe.idPoliticaAlertaVinculacion;
          }
          tempAlertaVinculacion.push(temp);
        });
        this.politicas.alertaVinculacion.forEach( e => {
          if ( e.idPoliticaAlertaVinculacion &&  e.indicadorHabilitado && !formulario.idVinculacionAlerta.find( y => y === e.idVinculacion ) ) {
            e.indicadorHabilitado = false;
            tempAlertaVinculacion.push( e );
          }
        } );
      }

      if ( formulario.idPerfil ) {
        formulario.idPerfil.map( sud => {
          let temp = {} as PoliticaPerfil;
          temp.idPerfilRiesgo = sud;
          temp.idPolitica = this.politicas.politica.idPolitica;
          temp.indicadorHabilitado = true;

          const existe = this.politicas.perfiles.find( x => x.idPerfilRiesgo === temp.idPerfilRiesgo);
          if(existe) {
            temp.idPoliticaPerfil = existe.idPoliticaPerfil;
          }
          tempPerfil.push(temp);
        });
        this.politicas.perfiles.forEach( e => {
          if ( e.idPoliticaPerfil &&  e.indicadorHabilitado && !formulario.idPerfil.find( y => y === e.idPerfilRiesgo ) ) {
            e.indicadorHabilitado = false;
            tempPerfil.push( e );
          }
        } );
      }

      if ( formulario.idOficinas && !this.politicasCredito) {
        formulario.idOficinas.map( sud => {
          let temp = {} as PoliticaOficina;
          temp.idEstructuraFisica = sud;
          temp.idPolitica = this.politicas.politica.idPolitica;
          temp.indicadorHabilitado = true;

          const existe = this.politicas.oficinas.find( x => x.idEstructuraFisica === temp.idEstructuraFisica);
          if(existe) {
            temp.idPoliticaOficina = existe.idPoliticaOficina;
          }
          tempOficina.push(temp);
        });
        this.politicas.oficinas.forEach( e => {
          if ( e.idPoliticaOficina &&  e.indicadorHabilitado && !formulario.idOficinas.find( y => y === e.idEstructuraFisica ) ) {
            e.indicadorHabilitado = false;
            tempOficina.push( e );
          }
        } );
      } else {
        tempOficina = this.guardarOficinasPolcre();
      }

      if(formulario.indicadorOficina && this.listaDescarteOficinas.length > 0) {
        tempDescarteOficina = this.listaDescarteOficinas;
        this.politicas.descarteOficinas.forEach( e => {
          if(e.idPoliticaDescarteOficina && e.indicadorHabilitado && !this.listaDescarteOficinas.find( y => y.idEstructuraFisica === e.idEstructuraFisica )){
            e.indicadorHabilitado = false;
            tempDescarteOficina.push( e );
          }
        });
      }


      if( formulario.indicadorPoliticaModalidad && formulario.idModalidadCredito){
        formulario.idModalidadCredito.map( sud => {
          let temp = {} as PoliticaModalidad;
          temp.idModalidadCredito = sud;
          temp.idPolitica = this.politicas.politica.idPolitica;
          temp.indicadorHabilitado = true;
          const existe = this.politicas.modalidades.find( x => x.idModalidadCredito === temp.idModalidadCredito);
          if(existe) {
            temp.idPoliticaModalidad = existe.idPoliticaModalidad;
          }
          tempModalidad.push(temp);
        });
        this.politicas.modalidades.forEach( e => {
          if ( e.idPoliticaModalidad &&  e.indicadorHabilitado && !formulario.idModalidadCredito.find( y => y === e.idModalidadCredito ) ) {
            e.indicadorHabilitado = false;
            tempModalidad.push( e );
          }
        } );
      }


      if( formulario.indicadorPoliticaProducto && this.listaPoliticaProducto.length > 0) {
        tempProductoPolitica = this.listaPoliticaProducto;
        this.politicas.productos.forEach( e => {
          if(e.idProductoPoliticaAlerta && e.indicadorHabilitado && !this.listaPoliticaProducto.find( y => y.idProducto === e.idProducto )){
            e.indicadorHabilitado = false;
            tempProductoPolitica.push( e );
          }
        });
      }

      if (!this.f.indicadorDescarta.value && !this.f.indicadorAlerta.value && !this.politicaReglasTalanquera) {
        this.valConDesAle = true;
        this.guardando = false;
        return false;
      }

      if (this.f.indicadorDescarta.value && this.f.indicadorAlerta.value) {
        this.validarVinculacion(tempDescarteVinculacion, tempAlertaVinculacion);
      }
      if(this.valDesAle){
        this.guardando = false;
        return false;
      }
      if ( d.codigo === CodigosPoliticas.PoliticaTipoAlerta && !this.politicaReglasParticipantes && !this.politicaReglasTalanquera) {
        if (formulario.idPerfil.length === 0 && !formulario.nota) {
          this.valPerNota = true;
          this.guardando = false;
          return false;
        }
      }

      if ( d.codigo === CodigosPoliticas.PoliticaPreselecta) {
        if (formulario.indicadorOficina && this.listaDescarteOficinas.length === 0 ){
            this.submittedOficinas = true;
            this.guardando = false;
            return false;
        } else {
          this.submittedOficinas = false;
        }
      }

      if ( d.codigo === CodigosPoliticas.PoliticasCredito) {

        if(!formulario.indicadorPoliticaGlobal && !formulario.indicadorPoliticaProducto && !formulario.indicadorPoliticaModalidad){
          this.valPolUniGen = true;
          this.guardando = false;
          return false;
        }

        if(this.politicas.politicasPlanteamientosPoliticas && this.politicas.politicasPlanteamientosPoliticas.length === 0) {
          this.valCodicionesPolitica = true;
          this.guardando = false;
          return false;
        }


        if(formulario.indicadorPoliticaProducto && this.listaPoliticaProducto.length === 0) {
          this.submittedProductos = true;
          this.guardando = false;
          return false;
        } else {
          this.submittedProductos = false;
        }
      }
      this.setearValores();
      await this.politicasPlanteamientosPoliticasService.bulk(this.politicas.lisPoliticaPlanteaminetoEliminadas).toPromise();
      const accion = !this.politica.idPolitica;
      this.politica.categoriaPolitica = d.nombre;
      const politica = await ( accion ? this.politicaService.crear( this.politica ) : this.politicaService.actualizar( this.politica ) ).toPromise();
      if (accion && this.listadoMatricesTemporal.length > 0) {
        this.listadoMatricesTemporal.forEach( d => {
          d.idPolitica = politica.idPolitica;
        });
       await  this.politicaService.bulkMatriz(this.listadoMatricesTemporal).toPromise();
        this.listadoMatricesTemporal = [];
      }
      if ( politica ) {
        this.politica.idPolitica = politica.idPolitica;
        if (this.politica.indicadorAplicaRol) {

          const tempRoles: PoliticasRoles[] = [];
          if (Array.isArray(formulario.idRol)) {
            formulario.idRol.forEach( rol => {
              const temp = {} as PoliticasRoles;
              temp.idPolitica = this.politica.idPolitica;
              temp.idRol = rol;
              temp.indicadorHabilitado = true;
              const _buscarReg = this.listaPoliticasRoles.find( sp => sp.idRol === temp.idRol &&  sp.idPolitica === temp.idPolitica);
              if ( _buscarReg ) {
                temp.idPoliticaRol = _buscarReg.idPoliticaRol;
              }
              tempRoles.push( temp );
            } );
          }

          this.listaPoliticasRoles.forEach( e => {
            if ( e.indicadorHabilitado && !formulario.idRol.find( y => y === e.idRol ) ) {
              e.indicadorHabilitado = false;
              tempRoles.push( e );
            }
          } );
          if ( tempRoles.length > 0 ) {
            this.politicasRolesService.bulk( tempRoles ).subscribe( res => {
              this.listaPoliticasRoles = res;
            } );
          }
        }
        const tempProductosPoliticasRetanqueo = [];
        this.productosPoliticasRetanqueoTodas.forEach(l => {
          const _buscarInhabilitado = this.productosPoliticasRetanqueo.find(y => y.idProducto === l.idProducto);
          if (!_buscarInhabilitado) {
            l.indicadorHabilitado = false;
            tempProductosPoliticasRetanqueo.push(l);
          }
        });

        this.productosPoliticasRetanqueo.forEach(s => {
          s.idPolitica = this.politica.idPolitica;
          tempProductosPoliticasRetanqueo.push(s);

        });
        this.politicasRetanqueoProductosService.bulk(tempProductosPoliticasRetanqueo).subscribe(async respuesta => {
          this.productosPoliticasRetanqueo.forEach(r => {
            const _buscarId = respuesta.find(x => x.idProducto === r.idProducto);
            r.idPoliticaRetanqueoProducto = _buscarId && _buscarId.idPoliticaRetanqueoProducto ? _buscarId.idPoliticaRetanqueoProducto : null;
          });
        });
        const consultas = [];
        if (formulario.idPaso && formulario.idPaso.length > 0) {
          const bulkPoliticasFlujos: PoliticaFlujoVentaPaso[] = [];
        formulario.idPaso.map(idFlujoVentaPaso => {
          const dato = {} as PoliticaFlujoVentaPaso;
          const existe = this.lisPoliticasFlujoVentaPasosTodos.find(x => x.idFlujoVentaPaso === idFlujoVentaPaso);
          dato.idPoliticaFlujoVentaPaso = (existe && existe.idPoliticaFlujoVentaPaso) ? existe.idPoliticaFlujoVentaPaso : null;
          dato.idPolitica = this.politica.idPolitica
          dato.idFlujoVentaPaso = idFlujoVentaPaso;
          dato.indicadorHabilitado = true;
          if (!existe || (existe && !existe.indicadorHabilitado)) {
            bulkPoliticasFlujos.push(dato);
          }
        });
        this.lisPoliticasFlujoVentaPasosTodos.forEach(x => {
          if (x.indicadorHabilitado && !formulario.idPaso.find(idFlujoVentaPaso => idFlujoVentaPaso === x.idFlujoVentaPaso)) {
            x.indicadorHabilitado = false;
            bulkPoliticasFlujos.push(x);
          }
        });
        if (bulkPoliticasFlujos.length > 0) {
          consultas.push(this.politicasFlujoVentaPasosService.bulk(bulkPoliticasFlujos));
        }
      }

        const setIndicadorFvpPol: boolean = this.validarFvpPolitica();


        if( this.banderaFvpPolitica ) {
          const resp = await this.flujoVentaPasoService.obtenerPorCofigoHabilitado('POLALE').toPromise();
          let temp = {} as PoliticaFlujoVenta;
          temp.codigoPolitica = this.politica.codigo;
          temp.politica = this.politica.nombre;
          temp.categoriaPolitica = this.politica.categoriaPolitica;
          temp.indicadorPoliticaProducto = this.politica.indicadorPoliticaProducto;
          temp.indicadorPoliticaModalidad = this.politica.indicadorPoliticaModalidad;
          temp.indicadorPoliticaGlobal = this.politica.indicadorPoliticaGlobal;
          temp.idPolitica = this.politica.idPolitica;
          temp.codigoCategoriaPolitica = this.politica.codigoCategoriaPolitica;
          temp.indicadorHabilitado = setIndicadorFvpPol;
          temp.idFlujoVentaPaso = resp.idFlujoVentaPaso;
          tempPoliticaGlobal.push(temp);
        }

        if(tempPoliticaGlobal.length > 0 && !this.politicaReglasParticipantes && !this.politicaReglasTalanquera){
          consultas.push(this.politicasConfiguradasService.bulk(tempPoliticaGlobal));
        }

        if (tempTipoVinculacion.length > 0 ) {
          tempTipoVinculacion.map(temp => {
            temp.idPolitica = politica.idPolitica;
          });
          consultas.push(this.politicasVinculacionesService.bulk(tempTipoVinculacion));
        }

        if (tempTipoProducto.length > 0 ) {
          tempTipoProducto.forEach(e => e.idPolitica = politica.idPolitica);
          consultas.push(this.politicaTipoProductoService.bulk(tempTipoProducto));
        }

        if (tempDescarteVinculacion.length > 0 ) {
          tempDescarteVinculacion.map(temp => {
            temp.idPolitica = politica.idPolitica;
          });
          consultas.push(this.politicaDescarteVinculacionService.bulk(tempDescarteVinculacion));
        }

        if (tempAlertaVinculacion.length > 0 ) {
          tempAlertaVinculacion.map(temp => {
            temp.idPolitica = politica.idPolitica;
          });
          consultas.push(this.politicaAlertaVinculacionService.bulk(tempAlertaVinculacion));
        }

        if (tempPerfil.length > 0 ) {
          tempPerfil.map(temp => {
            temp.idPolitica = politica.idPolitica;
          });
          consultas.push(this.politicasPerfilService.bulk(tempPerfil));
        }

        if (tempOficina.length > 0 ) {
          tempOficina.map(temp => {
            temp.idPolitica = politica.idPolitica;
          });
          consultas.push(this.politicasOficinaService.bulk(tempOficina));
        }

        if(formulario.indicadorOficina && this.listaDescarteOficinas.length > 0) {
          this.listaDescarteOficinas.map(temp => {
            temp.idPolitica = politica.idPolitica;
          });
          consultas.push(this.politicasDescarteOficinaService.bulk(this.listaDescarteOficinas));
        }

        if( formulario.indicadorPoliticaModalidad && formulario.idModalidadCredito){
          tempModalidad.map(temp => {
            temp.idPolitica = politica.idPolitica;
          });
          consultas.push(this.politicasModalidadService.bulk(tempModalidad));
        }

        if( formulario.indicadorPoliticaProducto && this.listaPoliticaProducto.length > 0) {
          tempProductoPolitica.map(temp => {
            temp.idPolitica = politica.idPolitica;
          });
          consultas.push(this.proPoliticaServicio.bulk(tempProductoPolitica));
        }

        if(this.politicas.politicasPlanteamientosPoliticas && this.politicas.politicasPlanteamientosPoliticas.length > 0) {
          this.politicas.politicasPlanteamientosPoliticas.map(temp => {
            temp.idPolitica = politica.idPolitica;
          });
          consultas.push(this.politicasPlanteamientosPoliticasService.bulk(this.politicas.politicasPlanteamientosPoliticas));
        }

        if( formulario.indicadorPerfilRiesgo && this.politicas.listPoliticasPerfilesRiesgos.length > 0) {
          this.politicas.listPoliticasPerfilesRiesgos.map(temp => {
            temp.idPolitica = politica.idPolitica;
          });
          consultas.push(this.politicaPerfilRiesgoService.bulk(this.politicas.listPoliticasPerfilesRiesgos));
        }

        this.formulario.markAsPristine();

        if (this.politicaReglasTalanquera) {
          if (this.formulario.dirty) {
            this.autServicio.sendNotificationPolitica(this.politica.idPolitica).toPromise();
          }
          this.politicas.politica = politica;
          this.politicas.politica.categoriaPolitica = this.politica.categoriaPolitica;
          this.nav.setMesage( 1 );
          this.guardando = false;
          return
        }

        forkJoin(
          consultas
        ).subscribe( response => {
          if (this.formulario.dirty) {
            this.autServicio.sendNotificationPolitica(this.politica.idPolitica).toPromise();
          }
          this.nav.setMesage( 1 );
          if (!salir) {
            this.politicas.politica = politica;
            this.politicas.politica.categoriaPolitica = this.politica.categoriaPolitica;
            this.guardando = false;
            this.validacionMatriz()
            return;
          }
          this.formulario.reset();
          this.regresar(false);
        }, error => {
          this.guardando = false;
          this.nav.setMesage( 3 );
        } );
      }

    }
  }

  setearValores(){

    this.politica = {} as Politica;
    this.politica.codigo = this.f.codigo.value;
    this.politica.nombre = this.f.nombre.value;
    this.politica.idCategoriaPolitica = this.f.idCategoriaPolitica.value;
    this.politica.idTipoAlerta = this.f.idTipoAlerta.value;
    this.politica.idEstado = this.f.idEstado.value;
    this.politica.idCausal = this.f.idCausal.value;
    this.politica.idNivel = this.f.idNivel.value;
    this.politica.idIdentificacionPolitica = this.f.idIdentificacionPolitica.value;
    this.politica.idIntegracion = this.f.idIntegracion.value;
    this.politica.idPaso = null;
    this.politica.ordenEjecucion = this.f.ordenEjecucion.value;
    this.politica.descripcion = this.f.descripcion.value;
    this.politica.definicion = this.f.definicion.value;
    this.politica.nota = this.f.nota.value;
    this.politica.respuesta = this.f.respuesta.value;

    this.politica.indicadorDescarta = this.f.indicadorDescarta.value;
    this.politica.indicadorDenegacionAutomatica = this.f.indicadorDenegacionAutomatica.value;
    this.politica.indicadorAlerta = this.f.indicadorAlerta.value;
    this.politica.indicadorExcepcion = this.f.indicadorExcepcion.value;
    this.politica.indicadorManejaAdjunto = this.f.indicadorManejaAdjunto.value;

    this.politica.indicadorNuevo = this.f.indicadorNuevo.value;
    this.politica.indicadorRenovacion = this.f.indicadorRenovacion.value;
    this.politica.indicadorOficina = this.f.indicadorOficina.value;
    this.politica.indicadorHabilitado = this.f.indicadorHabilitado.value;
    this.politica.indicadorPoliticaGlobal = this.f.indicadorPoliticaGlobal.value;
    this.politica.indicadorPoliticaProducto = this.f.indicadorPoliticaProducto.value;

    this.politica.indicadorPerfilRiesgo = this.f.indicadorPerfilRiesgo.value;
    this.politica.indicadorTasaMaxima = this.f.indicadorTasaMaxima.value;
    this.politica.indicadorAplicaRol = this.f.indicadorAplicaRol.value;

    this.politica.indicadorPoliticaModalidad = this.f.indicadorPoliticaModalidad.value;
    this.politica.indicadorReglaRetanqueo = this.f.indicadorReglaRetanqueo.value;
    this.politica.indicadorEjecucionIndividual = this.f.indicadorEjecucionIndividual.value;
    this.politica.idRespaldo = this.f.idRespaldo.value;

    if(this.politicas.politica && this.politicas.politica.idPolitica){
      this.politica.idPolitica = this.politicas.politica.idPolitica;
    }
    this.politica.indicadorPlataformaDigital =  this.f.indicadorPlataformaDigital.value;


    //this.politicas.politica.

  }


  validarVinculacion(descarteVinculacion: PoliticaDescarteVinculacion[], alertaVinculacion: PoliticaAlertaVinculacion[]){

    descarteVinculacion.forEach( e => {
      if(e.indicadorHabilitado) {
        if ( alertaVinculacion.find( y => y.idVinculacion === e.idVinculacion  && y.indicadorHabilitado) ) {
          this.valDesAle = true;
        }
      }
    });
  }

  async agregarOficinas(){

    this.guardando = true;
    const formulario = this.formulario.value;
    if ( formulario.idoficinasDescarte ) {
      formulario.idoficinasDescarte.map( sud => {
        let temp = {} as PoliticaDescarteOficina;
        temp.idEstructuraFisica = sud;
        temp.idPolitica = this.politicas.politica.idPolitica;
        temp.indicadorHabilitado = true;
        const d = this.listaOficinas.find( x => x.idEstructuraFisica === sud );
        if (d) {
          temp.estructura = d.estructuraFisica;
        }
        const existe = this.politicas.descarteOficinas.find( x => x.idEstructuraFisica === temp.idEstructuraFisica);
        if(existe) {
          temp.idPoliticaDescarteOficina = existe.idPoliticaDescarteOficina;
        }
        this.listaDescarteOficinas.push(temp);
      });

      this.cargaOficinas();
      await sleep(100);
      this.guardando = false;
      this.submittedOficinas = false;
      this.f.idoficinasDescarte.setValue([]);
    } else {
      this.submittedOficinas = true;
    }
  }

  cargaOficinasPolcre(){
    this.lisOficinas = [];
    this.listaOficinas.map( ( s: EstructuraFisica ) => {
      if ( !this.listOficinasPolcre.find( x => x.idEstructuraFisica === s.idEstructuraFisica ) ) {
        this.lisOficinas.push( { label: s.estructuraFisica, value: s.idEstructuraFisica } );
      }
    } );
    this.listOficinasPolcre.sort((a, b) => {
      if (a.estructura < b.estructura) {
        return -1;
      }
      if (a.estructura > b.estructura) {
        return 1;
      }
      return 0;
    });
  }

  cargaOficinas(){
    this.lisOficinas = [];
    this.listaOficinas.map( ( s: EstructuraFisica ) => {
      if ( !this.listaDescarteOficinas.find( x => x.idEstructuraFisica === s.idEstructuraFisica ) ) {
        this.lisOficinas.push( { label: s.estructuraFisica, value: s.idEstructuraFisica } );
      }
    } );
  }

  inhabilitarOficinasPolcre(oficina: any) {
    this.conServicio.confirm( {
      message: this.nav.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'oficinas',
      accept: async () => {
        this.guardando = true;
        const a = this.listOficinasPolcre.findIndex( x => x.idEstructuraFisica === oficina.idEstructuraFisica );
        if ( a >= 0 ) {
          this.listOficinasPolcre.splice( a, 1 );
          this.cargaOficinasPolcre();
          await sleep(100);
          this.guardando = false;
        }
      },
      reject: () => {
      }
    } );
  }

  guardarOficinasPolcre() {
    const lisEnviar: PoliticaOficina[] = [];
    if (this.politicasCredito) {
      if (this.listOficinasPolcre && this.listOficinasPolcre.length > 0) {
        this.listOficinasPolcre.forEach(po => {
          po.indicadorHabilitado = true;
          lisEnviar.push(po);
        });
      }
      if (this.listOficinasPolcreOriginal && this.listOficinasPolcreOriginal.length > 0) {
        this.listOficinasPolcreOriginal.forEach(po => {
          const buscar = this.listOficinasPolcre.find(dato => dato.idEstructuraFisica === po.idEstructuraFisica);
          if (!buscar) {
            po.indicadorHabilitado = false;
            lisEnviar.push(po);
          }
        });
      }
      if (this.politicas && this.politicas.oficinas && this.politicas.oficinas.length > 0 && lisEnviar.length > 0) {
        lisEnviar.forEach(temp => {
          const existe = this.politicas.oficinas.find( x => x.idEstructuraFisica === temp.idEstructuraFisica);
          if(existe) {
            temp.idPoliticaOficina = existe.idPoliticaOficina;
          }
        });
      }
    }
    return lisEnviar;
  }

  inhabilitarOficinas(oficina: PoliticaDescarteOficina) {

    this.conServicio.confirm( {
      message: this.nav.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'oficinas',
      accept: async () => {
        this.guardando = true;
        this.carInformacionInicial = true;
        const a = this.listaDescarteOficinas.findIndex( x => x.idEstructuraFisica === oficina.idEstructuraFisica );
        if ( a >= 0 ) {
          await sleep(100);
          this.guardando = false;
          this.listaDescarteOficinas.splice( a, 1 );
          this.cargaOficinas();
          this.carInformacionInicial = false;
        }
      },
      reject: () => {
      }
    } );
  }

  validarTipoPolitica(campo: string) {
    this.valPolUniGen = false;

      if(campo === 'Modalidad') {
        this.f.indicadorPoliticaGlobal.setValue(false)
        this.f.indicadorPoliticaModalidad.setValue(true);
        this.f.indicadorPoliticaProducto.setValue(false);
        this.f.idModalidadCredito.setValidators( [ Validators.required ] );
        this.f.idModalidadCredito.updateValueAndValidity();
      } else if(campo === 'Producto') {
        this.f.indicadorPoliticaGlobal.setValue(false)
        this.f.indicadorPoliticaModalidad.setValue(false);
        this.f.indicadorPoliticaProducto.setValue(true);
        this.f.idModalidadCredito.setValidators( null );
        this.f.idModalidadCredito.updateValueAndValidity();
      } else if(campo === 'Global'){
        this.f.indicadorPoliticaGlobal.setValue(true)
        this.f.indicadorPoliticaModalidad.setValue(false);
        this.f.indicadorPoliticaProducto.setValue(false);
        this.f.idModalidadCredito.setValidators( null );
        this.f.idModalidadCredito.updateValueAndValidity();
      }

  }

  validarTipoProceso() {
    this.tipoProcesoTradicional = true;
    if ( this.politicasCredito )
      this.f.idIdentificacionPolitica.setValidators(Validators.required);
    if(this.integracion){
      this.f.idIntegracion.setValidators(Validators.required);
    }
    if(this.paso){
      this.f.idPaso.setValidators(Validators.required);
    }
  }

  validarCheckEjecucionIndividual(event: any) {
    if (event.checked) {
      this.f.indicadorEjecucionIndividual.setValue(false);
    }
  }

  validarCheckPoliticaRetanqueo(event: any) {
    if (event.checked) {
      this.f.indicadorReglaRetanqueo.setValue(false);
    }
  }

  async agregarProducto(){

    this.guardando = true;
    const formulario = this.formulario.value;
    if ( formulario.idProducto ) {
      formulario.idProducto.map( sud => {
        let temp = {} as ProductoPoliticaAlerta;
        temp.idProducto = sud;
        temp.idPolitica = this.politicas.politica.idPolitica;
        temp.indicadorHabilitado = true;
        const d = this.listaProductos.find( x => x.idProducto === sud );
        if (d) {
          temp.codigoProducto = d.codigo;
          temp.producto = d.nombre;
          temp.modalidad = d.nombreModalidades;
          temp.codigoModalidad = d.codigoModalidades;
        }
        const existe = this.politicas.productos.find( x => x.idProducto === temp.idProducto);
        if(existe) {
          temp.idProductoPoliticaAlerta = existe.idProductoPoliticaAlerta;
        }
        this.listaPoliticaProducto.push(temp);
      });

      this.cargaProducto();
      await sleep(100);
      this.guardando = false;
      this.submittedProductos = false;
      this.f.idProducto.setValue([]);
    } else {
      this.guardando = false;
      this.submittedProductos = true;
    }
  }

  async agregarProductoPoliticaRetanqueo(){
    this.saveProductoRetanqueo = true;
    const _data = this.formulario.value;
    if ( _data.idPoliticaRetanqueoProducto.length > 0 ) {
      _data.idPoliticaRetanqueoProducto.map( sud => {
        let temp = {} as PoliticasRetanqueoProductos;
        temp.idProducto = sud;
        temp.idPolitica = this.politicas.politica && this.politicas.politica.idPolitica ? this.politicas.politica.idPolitica : null;
        temp.indicadorHabilitado = true;
        const d = this.listaProductosRetanqueo.find( x => x.idProducto === sud );
        if (d) {
          temp.codigoProducto = d.codigo;
          temp.producto = d.nombre;
          temp.productoModalidad = d.nombreModalidades;
        }
        this.productosPoliticasRetanqueo.push(temp);
      });
      this.cargaProductoPoliticaRetanqueo();
      await sleep(100);
      this.saveProductoRetanqueo = false;
      this.submittedProductosRetanqueo = false;
      this.f.idPoliticaRetanqueoProducto.setValue([]);

    } else {
      this.submittedProductosRetanqueo = true;
      this.saveProductoRetanqueo = false;
    }
  }

  cargaProductoPoliticaRetanqueo(){
    this.listaProductosPoliticasRetanqueo = [];
    this.listaProductosRetanqueo.map( ( s: Producto ) => {
      if ( !this.productosPoliticasRetanqueo.find( x => x.idProducto === s.idProducto ) ) {
        this.listaProductosPoliticasRetanqueo.push( { label: s.nombre, value: s.idProducto } );
      }
    } );
  }

  inhabilitarProductoRetanqueo(politicasRetanqueoProducto: any) {

    this.conServicio.confirm( {
      message: this.nav.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'retanqueo',
      accept: async () =>  {
        this.saveProductoRetanqueo = true;
        const a = this.productosPoliticasRetanqueo.findIndex( x => x.idProducto === politicasRetanqueoProducto.idProducto );
        if ( a >= 0 ) {
          await sleep(100);
          this.saveProductoRetanqueo = false;
          this.productosPoliticasRetanqueo.splice( a, 1 );
          this.cargaProductoPoliticaRetanqueo();
        }
      },
      reject: () => {
      }
    } );
  }

  cargaProducto(){
    this.lisProductos = [];
    this.listaProductos.map( ( s: Producto ) => {
      if ( !this.listaPoliticaProducto.find( x => x.idProducto === s.idProducto ) ) {
        this.lisProductos.push( { label: s.nombre, value: s.idProducto } );
      }
    } );
  }

  inhabilitarProducto(producto: PoliticaProducto) {

    this.conServicio.confirm( {
      message: this.nav.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.nav.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'oficinas',
      accept: async () =>  {
        //this.carInformacionInicial = true;
        this.guardando = true;
        const a = this.listaPoliticaProducto.findIndex( x => x.idProducto === producto.idProducto );
        if ( a >= 0 ) {
          await sleep(100);
          this.guardando = false;
          this.listaPoliticaProducto.splice( a, 1 );
          this.cargaProducto();
          //this.carInformacionInicial = false;
        }
      },
      reject: () => {
      }
    } );
  }

  tiposEjecucion() {
    if(this.f.idIdentificacionPolitica.value){
      this.integracion = false;
      this.paso = false;
      const d = this.listaTiposPolitica.find( d => d.idLista === this.f.idIdentificacionPolitica.value);
      if (d) {
        if(d.codigo === CodigosPoliticas.Integracion){
          this.integracion = true;
          this.f.idIntegracion.setValidators( [ Validators.required ] );
          this.f.idIntegracion.updateValueAndValidity();
          this.f.idPaso.setValidators( null );
          this.f.idPaso.updateValueAndValidity();
        }
        if(d.codigo === CodigosPoliticas.Paso){
          this.paso = true;
          this.f.idIntegracion.setValidators( null );
          this.f.idIntegracion.updateValueAndValidity();
          this.f.idPaso.setValidators( [ Validators.required ] );
          this.f.idPaso.updateValueAndValidity();
        }
      }
    } else {
      this.f.idIntegracion.setValidators( null );
      this.f.idIntegracion.updateValueAndValidity();
      this.f.idPaso.setValidators( null );
      this.f.idPaso.updateValueAndValidity();
    }


  }

  politicaPlanteamientoPoliticaEditado(){
    this.formulario.markAsDirty();
  }

  updatePoliticas(data: CentralizadaPoliticas) {
    this.f.ordenEjecucion.setValue(data.politica.ordenEjecucion);
  }

  validarPoliticaReglasParticipantes() {
    if (!this.f.codigo.value || !this.f.idCategoriaPolitica.value) {
      return
    }
    const categoria = this.politicas.listaCategoriasPoliticas.find( x => x.idLista === this.f.idCategoriaPolitica.value );
    if (this.f.codigo.value == CodigosPoliticas.PoliticaReglasParticipantes && categoria.codigo == CodigosPoliticas.PoliticaTipoAlerta) {
      this.politicaReglasParticipantes = true;
      this.actualizarFormulario()
    } else {
      this.politicaReglasParticipantes = false;
      this.actualizarFormulario()
    }
  }

  validarPoliticaReglasTalanquera() {
    if (!this.f.codigo.value || !this.f.idCategoriaPolitica.value) {
      return
    }
    const categoria = this.politicas.listaCategoriasPoliticas.find( x => x.idLista === this.f.idCategoriaPolitica.value );
    if (this.f.codigo.value == CodigosPoliticas.PoliticaReglasTalanquera && categoria.codigo == CodigosPoliticas.PoliticaTipoAlerta) {
      this.politicaReglasTalanquera = true;
      this.actualizarFormulario()
    } else {
      this.politicaReglasTalanquera = false;
      this.actualizarFormulario()
    }
  }

  showFormMatriz() {
    if (!this.matrizGeneral) {
      this.nav.setMesage( 0, {
        severity: 'info', summary: this.nav.buscarMensaje('LBL_INFORMACION'),
        detail: this.nav.buscarMensaje('POLITICAS.LBL_MSGMATRIZGENERAL')
      });
      return;
    }
    this.formMatriz = true;
  }

  async validacionMatriz() {
    if (this.politicas && this.politicas.politica && this.politicas.politica.idPolitica) {
      this.politicaService.getMatriz(this.politicas.politica.idPolitica).subscribe(
        (response) => {
          if (response) {
            this.listadoMatrices = response;
            // this.matrizGeneral = this.listadoMatrices.find( x => x.indicadorExcluidaddelConteo === null && x.indicadorRestriccionUnidadCredito === null );
            this.matrizGeneral = this.listadoMatrices.find( x => x.indicadorExcluidaddelConteo === null);
            this.listadoMatricesModalidad = this.listadoMatrices.slice(1);
            this.cargarListaModalidades();
          }
        },
        (error) => {
          this.nav.setMesage(3);
          // this.cargaNiveles = false;
        }
      );
    } else {
      this.cargarListaModalidades();
    }
  }

  async agregarMatriz() {
    let modalidad = await this.obtenerModalidad()
    let validacionModalidad = await this.validarMatrizModalidad(modalidad)

    if (validacionModalidad) {
      this.nav.setMesage(4, {
        severity: "info",
        summary: this.nav.buscarMensaje("LBL_INFORMACION"),
        detail: this.nav.buscarMensaje("POLITICAS.MSG_MATRIZCONFIGURADA"),
      });
      return
    }

    let matriz: PoliticasMatrizVinculaciones = {
      matriz: modalidad.nombre,
      idModalidad: modalidad.idModalidad,
      // indicadorRestriccionUnidadCredito: false,
      indicadorExcluidaddelConteo: false,
      politicasMatrizVinculacionesList: [{idModalidad: modalidad.idModalidad}]
    }


    this.listadoMatricesModalidad.push(matriz)
    this.f.modalidadMatriz.setValue(null)
    this.formMatriz = false
    this.cargarListaModalidades();

  }

  cargarListaModalidades() {
    this.lisModalidades = [];
    const listaTemporal = [];
    this.listadoMatricesModalidad.forEach(x => {
      x.politicasMatrizVinculacionesList.forEach(l => {
        listaTemporal.push(l);
      });
    });
    this.listaModalidades.map( ( s ) => {
      if ( !listaTemporal.find(z => z.idModalidad === s.idModalidad)) {
        this.lisModalidades.push( { label: s.nombre, value: s.idModalidad } );
      }
    } );
  }


  validarMatrizModalidad(modalidad: Modalidad) {
    let existeModalidad = this.listadoMatricesModalidad.find(
      (matrizModalidad) => {
        if (matrizModalidad.politicasMatrizVinculacionesList && matrizModalidad.politicasMatrizVinculacionesList.length == 3) {
          return matrizModalidad.politicasMatrizVinculacionesList[0].idModalidad === modalidad.idModalidad;
        } else {
          return matrizModalidad.matriz === modalidad.nombre;
        }
      }
    ) ? true : false;

    return existeModalidad
  }

  obtenerModalidad() {
    let modalidad = this.listaModalidades.find(
      (modalidad) => modalidad.idModalidad === this.f.modalidadMatriz.value
    )
    return modalidad
  }

  eliminarMatriz(index: number) {
    this.listadoMatricesTemporal = this.listadoMatricesTemporal.filter(l =>
      l.idModalidad !== this.listadoMatricesModalidad[index].idModalidad
    );
    this.listadoMatricesModalidad.splice(index, 1);
    this.cargarListaModalidades();
  }

  actualizarFormulario() {
    // Se actualiza los campos obligatorios para la politica REGPAR ("reglas de participantes")
    if (this.politicaReglasParticipantes || this.politicaReglasTalanquera) {
      this.f.idsVinculaciones.setValidators( null );
      this.f.idsVinculaciones.updateValueAndValidity();
    } else {
      this.f.idsVinculaciones.setValidators( [ Validators.required ] );
      this.f.idsVinculaciones.updateValueAndValidity();
    }
  }

  guardarMatrizTemporal(lista: any, matrizGeneral: boolean = false) {
    if (matrizGeneral) {
      this.matrizGeneral = lista[0];
    }
    if (this.politica) {
      return;
    }
    lista.forEach(x => {
      const _index = this.listadoMatricesTemporal.findIndex(l => l.idVinculacion === x.idVinculacion && l.idModalidad === x.idModalidad);
      if (_index >= 0 ) {
        this.listadoMatricesTemporal[_index].valorTitular = x.valorTitular;
        this.listadoMatricesTemporal[_index].valorDeudor = x.valorDeudor;
        this.listadoMatricesTemporal[_index].valorCodeudor = x.valorCodeudor;
        this.listadoMatricesTemporal[_index].indicadorExcluidaddelConteo = x.indicadorExcluidaddelConteo;
      } else {
        this.listadoMatricesTemporal.push(x);
      }
    });



  }

  async agregarOficinaPolcre() {
    const formulario = this.formulario.value;
    if ( formulario.idOficinasPolcre ) {
      this.guardando = true;
      formulario.idOficinasPolcre.map( sud => {
        let temp = {} as PoliticaOficina;
        temp.idEstructuraFisica = sud;
        const d = this.listaOficinas.find( x => x.idEstructuraFisica === sud );
        if (d) {
          temp.estructura = d.estructuraFisica;
          temp.codigo = d.codigo;
        }
        temp.indicadorHabilitado = true;
        this.listOficinasPolcre.push(temp);
      });
      this.f.idOficinasPolcre.setValue([]);
      this.cargaOficinasPolcre();
      await sleep(100);
      this.guardando = false;
    }
  }

  validarFvpPolitica(): boolean {
    const fvpPolitica = this.flujoVentaPasosPoliticas.find(x => x.idPolitica === this.politica.idPolitica);
    let respuesta = false;

    if (fvpPolitica) {
      this.banderaFvpPolitica = true;

      if (!this.politica.indicadorPoliticaGlobal && fvpPolitica.indicadorHabilitado) {
        respuesta = fvpPolitica.indicadorPoliticaGlobal ? false : this.politica.indicadorHabilitado;
      } else if (this.politica.indicadorPoliticaGlobal) {
        respuesta = this.politica.indicadorHabilitado;
      }
    } else if (this.politica.indicadorPoliticaGlobal) {
      this.banderaFvpPolitica = true;
      respuesta = true;
    } else {
      this.banderaFvpPolitica = false;
    }

    return respuesta;
  }



  // Funcion para encontrar controles inválidos
  findInvalidControls() {
    const invalidControls: string[] = [];
    const controls = this.formulario.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalidControls.push(name);
      }
    }
    return invalidControls;
  }

  validarRequerirRespaldo() {
    const d = this.politicas.listaCategoriasPoliticas.find( x => x.idLista === this.f.idCategoriaPolitica.value );
    if (d && d.codigo === CodigosPoliticas.PoliticasCredito && this.f.indicadorManejaAdjunto.value) {
        this.habilitarRespaldo = true;
        this.f.idRespaldo.setValidators( [ Validators.required ] );
      this.f.idRespaldo.updateValueAndValidity();
    } else {
      this.f.idRespaldo.setValidators(null);
      this.f.idRespaldo.updateValueAndValidity();
      this.habilitarRespaldo = false;
      this.f.idRespaldo.setValue(null);
    }
  }

  async validarRequeirirRoles() {
    if (this.f.indicadorAplicaRol.value) {
      this.f.idRol.setValidators( [ Validators.required ] );
      this.f.idRol.updateValueAndValidity();
    } else {
      this.f.idRol.setValidators(null);
      this.f.idRol.updateValueAndValidity();
    }
  }
}
